import ScrollReveal from "../../../components/feature/ScrollReveal";
import { scenesData } from "../../../mocks/yokohamaData";

export default function ScenesSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-3">{scenesData.label}</p>
              <h2 className="section-title">{scenesData.title}</h2>
              <p className="section-subtitle max-w-2xl mx-auto">{scenesData.subtitle}</p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {scenesData.items.map((item, idx) => (
              <ScrollReveal key={item.title} direction="up" delay={idx * 100}>
                <div className="group relative overflow-hidden rounded-lg">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-airdoa-navy/90 via-airdoa-navy/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <p className="text-[10px] font-medium tracking-ultra text-airdoa-gold uppercase mb-2">
                      {item.tag}
                    </p>
                    <h3 className="text-lg md:text-xl font-serif font-semibold text-white">{item.title}</h3>
                    <p className="mt-2 text-sm text-white/70 leading-[1.9]">{item.desc}</p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
